/**
 * copyToClipboard() - method that copy value of passed element to clipboard
 *
 * @param {String} element
 */

const copyToClipboard = (element) => {
  navigator.clipboard.writeText(element.currentTarget.dataset.value);
};

export default copyToClipboard;
